import React from 'react';

const useSlider = (children: React.ReactNode) => {
  const childrenArray = React.Children.toArray(children);

  return { childrenArray };
};

export default useSlider;
